<div class="event-card summary-card event-card--interactive"
     [class.summary-card--compact]="compact"
     [class.event-card--interactive]="interactive">
  <a #link [routerLink]="['/event', aviationEvent.eventId]" class="event-card__wrapper"
     [class.event-card__wrapper--active]="active"
     (mouseover)="onHover(true)" (mouseleave)="onHover(false)">
    <div class="event-card__row" *ngIf="aviationEvent.format === 'Online'">
        <div class="event-card__online-event">ONLINE EVENT</div>
    </div>
    <div class="event-card__row">
      <div *ngIf="compact" class="event-card__event-type-compact">{{ aviationEventTypeDesc[aviationEventType[aviationEvent.typeId]].toLowerCase() }}</div>
      <div *ngIf="compact" class="event-card__main-compact">
        <div class="event-card__header-left">
          <h2 class="event-card__name">{{ aviationEvent.title }}</h2>
          <div class="event-card__text">{{ getDateString(aviationEvent, 'start') }}<ng-container *ngIf="getDateString(aviationEvent, 'start') !== getDateString(aviationEvent, 'end')"> - {{ getDateString(aviationEvent, 'end') }}</ng-container></div>
          <div class="event-card__body">
            <div *ngIf="aviationEvent.venueLocationName" class="event-card__text">
              {{ aviationEvent.venueLocationName }}
            </div>
            <div *ngIf="aviationEvent.address1" class="event-card__text">
              {{ aviationEvent.address1 }}
            </div>
            <div *ngIf="aviationEvent.city && aviationEvent.stateProvince" class="event-card__text">
              {{ aviationEvent.city }}, {{ aviationEvent.stateProvince }} <ng-container *ngIf="aviationEvent.zipcode">{{ aviationEvent.zipcode }}</ng-container>
            </div>
            <div *ngIf="aviationEvent.country && aviationEvent.country !== 'United States'" class="event-card__text">
              {{ aviationEvent.country }}
            </div>
          </div>
        </div>
        <div *ngIf="aviationEvent.photos && aviationEvent.photos.length > 0 && aviationEvent.photos[0].thumbnailPhotoPath" class="event-card__header-right-photo">
          <div *ngIf="aviationEvent.photos && aviationEvent.photos.length > 0 && aviationEvent.photos[0].thumbnailPhotoPath" class="event-card__photo">
            <img class="event-card__image-border" [src]="aviationEvent.photos[0].thumbnailPhotoPath" />
          </div>
        </div>
      </div>

      <div *ngIf="!compact" class="event-card__event-type">{{ aviationEventTypeDesc[aviationEventType[aviationEvent.typeId]].toLowerCase() }}</div>
      <div *ngIf="!compact" class="event-card__main">
        <div class="event-card__header">
          <div class="event-card__header-left">
            <h2 class="event-card__name">{{ aviationEvent.title }}</h2>
            <div class="event-card__text">{{ getDateString(aviationEvent, 'start') }}<ng-container *ngIf="getDateString(aviationEvent, 'start') !== getDateString(aviationEvent, 'end')"> - {{ getDateString(aviationEvent, 'end') }}</ng-container></div>
            <div *ngIf="aviationEvent.venueLocationName" class="event-card__text">
              Location: {{ aviationEvent.venueLocationName }}
            </div>
          </div>
          <div class="event-card__header-right">
            <app-event-favorite-icon [eventId]="aviationEvent.eventId"></app-event-favorite-icon>
          </div>
        </div>
        <div class="event-card__body">
          <div *ngIf="aviationEvent.shortDescription" class="event-card__text">
            Description:
            <div>{{ aviationEvent.shortDescription }}</div>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>

<ng-template #na>
  <span class="na">--</span>
</ng-template>
